import { render, staticRenderFns } from "./tools-toolbar.vue?vue&type=template&id=45bb4e77&scoped=true&"
import script from "./tools-toolbar.ts?vue&type=script&lang=ts&"
export * from "./tools-toolbar.ts?vue&type=script&lang=ts&"
import style0 from "./tools-toolbar.scss?vue&type=style&index=0&id=45bb4e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb4e77",
  null
  
)

export default component.exports